import { __decorate } from "tslib";
import { Component, Vue, Prop, Model, Watch } from 'vue-property-decorator';
// import FaceSelection from '@blade-sxp/tools/components/face-selection.vue';
import { createDialog } from '@blade-sxp/tools/utils/dialogControl';
import { includes, last, toLower } from 'lodash';
import { getDetect } from '@blade-sxp/tools/apis';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import SelectPortrait from '@blade-sxp/tools/components/select-portrait.vue';
import FaceSelection from '@blade-sxp/tools/components/face-selection.vue';
let ImgBox = class ImgBox extends Vue {
    canDelete;
    maxSize;
    choiceIcon = require('@blade-sxp/tools/assets/images/choiceIcon.svg');
    deleteIcon = require('@blade-sxp/tools/assets/images/deleteIcon.svg');
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    loading = false;
    types = ['jpg', 'bmp', 'jpeg', 'png'];
    hover = false;
    onImageUrlChange(value) {
        this.dispatch('ElFormItem', 'el.form.change', [value]); // 值发生变化时, 向el-form-item分发事件 , 调用组件内部的校验流程
    }
    value;
    get accept() {
        return this.types.map((item) => `image/${item}`).join(', ');
    }
    dispatch(componentName, eventName, params) {
        let parent = this.$parent || this.$root;
        let name = parent.$options.componentName;
        while (parent && (!name || name !== componentName)) {
            parent = parent.$parent;
            if (parent) {
                name = parent.$options.componentName;
            }
        }
        if (parent) {
            parent.$emit.apply(parent, [eventName].concat(params));
        }
    }
    convertBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onerror = (e) => reject(e);
        }).catch((e) => console.log('error', e));
    }
    openPortrait() {
        let dialog = createDialog(SelectPortrait, {});
        dialog
            .then((data) => {
            if (typeof data !== 'string') {
                const { imageUrl, ...otherProps } = data;
                data && this.handleValueChange({ type: 0, value: imageUrl, ...otherProps });
            }
        })
            .catch((err) => console.log(err));
    }
    handleValueChange(value) {
        this.$emit('change', value);
    }
    openDialog(featureList, resourceImg) {
        let dialog = createDialog(FaceSelection, {
            featureList,
            resourceImg,
        });
        dialog.then((data) => {
            if (typeof data !== 'string') {
                const { base64Img, ...otherProps } = data;
                this.handleValueChange({ type: 1, value: base64Img, ...otherProps });
            }
        });
    }
    init() {
        this.handleValueChange({});
    }
    async handleImgChose(data) {
        const { raw, name, size } = data;
        const base64Image = (await this.convertBase64(raw));
        await this.isFormatValid(name, size, base64Image);
    }
    async isFormatValid(name, size, base64Image) {
        const suffix = last(name.split('.'));
        const nameValid = includes(this.types, toLower(suffix));
        const maxSize = Number(this.maxSize) || 0;
        const sizeValid = maxSize <= 0 || size <= maxSize * 1024 * 1024;
        if (!nameValid)
            return this.$message.error(this.$t('wrongFile'));
        if (!sizeValid)
            return this.$message.error(`${this.$t('wrongSize')}${maxSize}m!`);
        return this.onUpload(base64Image);
    }
    async onUpload(base64Image) {
        this.loading = true;
        try {
            const res = await getDetect(base64Image);
            this.loading = false;
            if (res.length > 0) {
                this.openDialog(res, base64Image);
            }
        }
        catch (e) {
            this.loading = false;
        }
    }
};
__decorate([
    Prop({ default: true, type: Boolean })
], ImgBox.prototype, "canDelete", void 0);
__decorate([
    Prop(Number)
], ImgBox.prototype, "maxSize", void 0);
__decorate([
    Watch('value')
], ImgBox.prototype, "onImageUrlChange", null);
__decorate([
    Model('change', {
        type: Object,
    })
], ImgBox.prototype, "value", void 0);
ImgBox = __decorate([
    Component({
        name: 'ImgBox',
        components: { BlurPicture },
        i18n: {
            messages: {
                en: {
                    upload: 'click to upload or drag a image here',
                    file: 'supported format: .jpeg .png .bmp .jpg',
                    btn: 'Select from portrait libraries',
                    wrongFile: 'The file format is invalid!',
                    wrongSize: 'File size exceeds ',
                },
                zh: {
                    upload: '拖拽图片至此或点击选择文件上传',
                    file: '支持文件格式：PNG 、JPEG 、BMP 、JPG',
                    btn: '从人像库中选择',
                    wrongFile: '文件类型有误！',
                    wrongSize: '文件大小超过',
                },
            },
        },
    })
], ImgBox);
export default ImgBox;
